module.exports = __webpack_public_path__ + "static/img/classcard-one.0c6c111.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/classcard-one.png
// module id = ajif
// module chunks = 0